/**
 * Determines whether a pathname is the base path itself or one of its descendant routes.
 * Matching is segment aware, so `/employee-benefits` is not treated as a descendant of `/employee`.
 * @param pathname The current location pathname.
 * @param basePath The base path to test against.
 * @returns True when the pathname is the base path or a route beneath it.
 */
export const isPathWithinBasePath = (pathname: string, basePath: string): boolean => {
  if (!basePath) return false;

  const normalizedBasePath = basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;

  /* A base path of "/" normalizes to an empty string and matches every route. */
  if (!normalizedBasePath) return true;

  return pathname === normalizedBasePath || pathname.startsWith(`${normalizedBasePath}/`);
};
